class VanillaInvitationCircleHover {
  constructor(options = {}) {
    this.innerSelector = options.innerSelector || ".js-ivtn-box-itm-inner";
    this.circleSelector = options.circleSelector || ".js-ivtn-box-itm-cir";

    this.explodeClass = options.explodeClass || "explode-circle";
    this.desplodeClass = options.desplodeClass || "desplode-circle";

    this.init();
  }

  init() {
    const inners = document.querySelectorAll(this.innerSelector);

    if (!inners.length) return;

    inners.forEach((inner) => {
      inner.addEventListener("mouseenter", (event) => {
        this.handleMouseEnter(event, inner);
      });

      inner.addEventListener("mouseleave", (event) => {
        this.handleMouseLeave(event, inner);
      });
    });
  }

  getCircle(inner) {
    const circle = inner.previousElementSibling;

    if (!circle || !circle.matches(this.circleSelector)) {
      return null;
    }

    return circle;
  }

  getMousePosition(event, element) {
    const rect = element.getBoundingClientRect();

    return {
      x: event.clientX - rect.left,
      y: event.clientY - rect.top,
    };
  }

  setCirclePosition(circle, position) {
    circle.style.left = `${position.x}px`;
    circle.style.top = `${position.y}px`;
  }

  handleMouseEnter(event, inner) {
    const circle = this.getCircle(inner);

    if (!circle) return;

    const position = this.getMousePosition(event, inner);

    this.setCirclePosition(circle, position);

    circle.classList.remove(this.desplodeClass);
    circle.classList.add(this.explodeClass);
  }

  handleMouseLeave(event, inner) {
    const circle = this.getCircle(inner);

    if (!circle) return;

    const position = this.getMousePosition(event, inner);

    this.setCirclePosition(circle, position);

    circle.classList.remove(this.explodeClass);
    circle.classList.add(this.desplodeClass);
  }
}

export default VanillaInvitationCircleHover;
